export enum AccordionAlign {
  CENTER = 'center',
  LEFT = 'left',
}

export interface AccordionCopyToClipboard {
  enabled: boolean;
  text: string;
}
